import { useEffect } from "react";

export const useCloseMenuEscapeButton = ({
    isOpen,
    closeMenu,
}: {
    isOpen: boolean;
    closeMenu: () => void;
}) => {
    useEffect(() => {
        const handleCloseMenuEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape" || event.key === "Esc") {
                closeMenu();
            }
        };

        if (isOpen) {
            window.addEventListener("keydown", handleCloseMenuEscape);
        }

        return () => {
            window.removeEventListener("keydown", handleCloseMenuEscape);
        };
    }, [closeMenu, isOpen]);
};
